import * as React from "react";
const InformationIcon = ({
  className,
  width = 24,
  height = 24,
}: {
  className?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#D4D4DA"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.192a8 8 0 0 0-5.656 2.344 7.997 7.997 0 0 0 0 11.313 7.997 7.997 0 0 0 11.312 0A8 8 0 0 0 20 12.192a8.007 8.007 0 0 0-8-8m0 14.4a6.4 6.4 0 1 1 6.4-6.4 6.405 6.405 0 0 1-6.4 6.4m0-8a.8.8 0 0 0-.8.8v4a.8.8 0 0 0 1.6 0v-4a.8.8 0 0 0-.8-.8m.8-1.6c0 1.067-1.6 1.067-1.6 0s1.6-1.066 1.6 0"
    />
  </svg>
);
export default InformationIcon;
